import { JSONSchemaType } from 'ajv'
import validationPatters from 'schema/patterns'

export interface IInviteResponsibleFormData {
  responsibleEmail: string
  responsibleName: string
}

const InviteResponsibleSchema: JSONSchemaType<IInviteResponsibleFormData> = {
  type: 'object',
  additionalProperties: false,
  properties: {
    responsibleEmail: {
      type: 'string',
      pattern: validationPatters.email,
      minLength: 1,
      errorMessage: 'Por favor, insira um endereço de e-mail válido.',
    },
    responsibleName: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Este campo não pode estar em branco.',
    },
  },
  required: ['responsibleEmail', 'responsibleName'],
}

export default InviteResponsibleSchema
